var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, AccordionDetails as MuiAccordionDetails, } from '@mui/material';
import { ChevronDownIcon } from '@localina/icons';
import { Label } from '../Label';
export var Accordion = function (props) {
    var className = 'localina-accordion';
    return (_jsxs(MuiAccordion, __assign({ className: className, square: true, defaultExpanded: props.defaultExpanded }, { children: [_jsx(MuiAccordionSummary, __assign({ className: "".concat(className, "__summary"), expandIcon: _jsx(ChevronDownIcon, {}) }, { children: _jsx(Label, { type: "title", variant: "h6", value: props.title }) })), _jsx(MuiAccordionDetails, __assign({ className: "".concat(className, "__details") }, { children: props.children }))] })));
};
